import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import {
  HomeOutlined,
  CloudSyncOutlined,
  TeamOutlined,
  FilePdfOutlined,
  LogoutOutlined,
  ShoppingCartOutlined,
  FileTextOutlined,
  BarChartOutlined,
  CustomerServiceOutlined,
  EnvironmentOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { logout, fetchApplications } from "../../store/auth/authSlice";
import {
  removeToken,
  removeUsername,
  removeApplications,
} from "../../store/auth/cookieUtils";
import "./NavBodecom.css";

const NavBodecom = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { applications, isAuthenticated, is_group5, user } = useSelector(
    (state) => state.auth
  );
  const isGroup5 = Boolean(user?.is_group5 ?? is_group5);

  useEffect(() => {
    if (isAuthenticated && applications.length === 0) {
      dispatch(fetchApplications());
    }
  }, [isAuthenticated, applications, dispatch]);

  const handleLogout = async () => {
    try {
      removeToken();
      removeUsername();
      removeApplications();
      await dispatch(logout());
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  const disabledItems = ["/mer", "/organizaciones", "/mapas", "/reportes"];

  const menuItems = [
    {
      path: "/inicio",
      icon: <HomeOutlined />,
      label: "Inicio",
      appName: "inicio",
    },
    {
      path: "/participantes",
      icon: <TeamOutlined />,
      label: "Participantes",
      appName: "participantes-paati",
      parent: "PAATI",
    },

    {
      path: "/visitas-tecnicas-sostenibilidad",
      icon: <FilePdfOutlined />,
      label: "Visitas tecnicas",
      appName: "visitas-tecnicas-sostenibilidad",
      parent: "visitas-tecnicas-sostenibilidad",
    },
    { path: "/poa", icon: <FilePdfOutlined />, label: "POA", appName: "poa" },
    {
      path: "/planOperativo",
      icon: <FilePdfOutlined />,
      label: "Plan Operativo",
      appName: "poas",
      parent: "poas",
    },
    {
      path: "/novedades",
      icon: <FilePdfOutlined />,
      label: "NOVEDADES",
      appName: "novedades",
    },
    {
      path: "/bodegas",
      icon: <FilePdfOutlined />,
      label: "Bodegas",
      appName: "bodegas",
      parent: "bodegas",
    },

    {
      path: "/ordenesdeservicio",
      icon: <FilePdfOutlined />,
      label: "Ordenes de servicio",
      appName: "ordenesdeservicio",
      parent: "financiero",
    },

    {
      path: "/stock",
      icon: <FilePdfOutlined />,
      label: "Stock reservas",
      appName: "stock",
      parent: "financiero",
    },

    {
      path: "/entregassostenibilidad",
      icon: <FilePdfOutlined />,
      label: "Asignación SOSTENIBILIDAD",
      appName: "entregassostenibilidad",
      parent: "financiero",
    },

    {
      path: "/proveedores",
      icon: <FilePdfOutlined />,
      label: "Proveedores",
      appName: "proveedores",
      parent: "financiero",
    },

    {
      path: "/productos",
      icon: <FilePdfOutlined />,
      label: "Productos",
      appName: "productos",
      parent: "financiero",
    },
    {
      path: "/planesdecompras",
      icon: <FilePdfOutlined />,
      label: "Planes de compras",
      appName: "planesdecompras",
    },
    {
      path: "/planesdecomprasostenibilidad",
      icon: <FilePdfOutlined />,
      label: "Planes de compra Sostenibilidad",
      appName: "planesdecomprasostenibilidad",
    },
    {
      path: "/participantes-sostenibilidad",
      icon: <TeamOutlined />,
      label: "Participantes",
      appName: "/participantes-sostenibilidad",
      parent: "participantes-sostenibilidad",
    },

    {
      path: "/informeSeguimientoMonitoreo",
      icon: <BarChartOutlined />,
      label: "Seguimiento y Monitoreo",
      appName: "informeSeguimientoMonitoreo",
      parent: "informeSeguimientoMonitoreo",
    },
    {
      path: "/informe-visitasTecnicas",
      icon: <BarChartOutlined />,
      label: "Informe Visitas Técnicas",
      appName: "informeVisitasTecnicas",
      parent: "informeVisitasTecnicas",
    },
    {
      path: "/informe-novedades",
      icon: <BarChartOutlined />,
      label: "Informe de Novedades",
      appName: "informeNovedades",
      parent: "informeNovedades",
    },

    {
      path: "/informe-autorizacionImagen",
      icon: <BarChartOutlined />,
      label: "Informe de autorización de imagen",
      appName: "informeAutorizacionImagen",
      parent: "informeAutorizacionImagen",
    },

    {
      path: "/informePlanComprasPaati",
      icon: <BarChartOutlined />,
      label: "Informe plan de compras",
      appName: "informePlanComprasPaati",
      parent: "informePlanComprasPaati",
    },

    {
      path: "/informe-visitas-tecnicas-sostenibilidad",
      icon: <BarChartOutlined />,
      label: "Informe de visitas técnicas de sostenibilidad",
      appName: "informe-visitas-tecnicas-sostenibilidad",
      parent: "informe-visitas-tecnicas-sostenibilidad",
    },
    {
      path: "/historial-visitas-paati",
      icon: <BarChartOutlined />,
      label: "Historial documentos PAATI",
      appName: "historial-visitas-paati",
      parent: "historial-visitas-paati",
    },

    {
      path: "/gestorArchivosPAATI",
      icon: <FolderOpenOutlined />,
      label: "gestor de archivos PAATI",
      appName: "gestorArchivosPAATI",
      parent: "gestorArchivosPAATI",
    },

    {
      path: "/mapa-paati",
      icon: <EnvironmentOutlined />,
      label: "Geovisor PAATI",
      appName: "mapa-paati",
      parent: "mapa-paati",
    },

        {
      path: "/mapa-sostenibilidad",
      icon: <EnvironmentOutlined />,
      label: "Geovisor SOSTENIBILIDAD",
      appName: "mapa-sostenibilidad",
      parent: "mapa-sostenibilidad",
    },

    {
      path: "/mapa-arn",
      icon: <EnvironmentOutlined />,
      label: "Geovisor ARN",
      appName: "mapa-arn",
      parent: "mapa-arn",
    },
    {
      path: "/informeMonitoreoEspiga",
      icon: <BarChartOutlined />,
      label: "Informe espiga",
      appName: "informe-espiga",
      parent: "informe-espiga",
    },

    {
      path: "/informeIngresoPO",
      icon: <BarChartOutlined />,
      label: "Informe Ingreso PO",
      appName: "informe-ingreso-po",
      parent: "informe-ingreso-po",
    },
  ];

  const userApplications = Array.isArray(applications)
    ? applications.map((a) => a.app_name)
    : [];

  return (
    <Navbar bg="light" expand="lg" className="mb-4 full-width-navbar pl-5">
      <div className="navbar-container">
        <div className="container">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              {/* Inicio */}
              {userApplications.includes("inicio") &&
                isAuthenticated &&
                !isGroup5 && (
                  <Nav.Link
                    key="inicio"
                    as={Link}
                    to="/inicio"
                    className="nav-link"
                  >
                    <HomeOutlined /> Inicio
                  </Nav.Link>
                )}

              {/* PAATI Dropdown */}
              {userApplications.includes("buscar-proyecto") && (
                <>
                  {/* 🔹 Participnates" */}
                  <NavDropdown
                    title={
                      <span>
                        <CloudSyncOutlined /> PAATI
                      </span>
                    }
                    id="paati-dropdown"
                  >
                    {menuItems
                      .filter((item) => item.parent === "PAATI")
                      .map((subItem) => (
                        <NavDropdown.Item
                          key={subItem.path}
                          as={Link}
                          to={
                            disabledItems.includes(subItem.path)
                              ? "#"
                              : subItem.path
                          }
                          onClick={(e) => {
                            if (disabledItems.includes(subItem.path)) {
                              e.preventDefault();
                            }
                          }}
                        >
                          {subItem.icon} {subItem.label}
                        </NavDropdown.Item>
                      ))}

                    {/* 🔹 Submenú "Planes de Compra - PATTI" */}
                    <NavDropdown
                      title={
                        <span>
                          <ShoppingCartOutlined /> Compras
                        </span>
                      }
                      id="planes-de-compra-dropdown"
                      drop="end"
                    >
                      {userApplications.includes("planesdecompras") && (
                        <NavDropdown.Item as={Link} to="/planesdecompras">
                          <FilePdfOutlined /> Planes de Compra
                        </NavDropdown.Item>
                      )}
                    </NavDropdown>

                    {/* 🔹 Submenú "Seguimiento - Informes - PATTI" */}
                    {/* 🔹 Submenú "Seguimiento - Informes - PATTI" */}
                    {userApplications.includes("dashboard") && (
                      <NavDropdown
                        title={
                          <span>
                            <FileTextOutlined /> Dashboards
                          </span>
                        }
                        id="dashboards-patti-dropdown"
                        drop="end"
                      >
                        {[
                          "informeSeguimientoMonitoreo",
                          "informeVisitasTecnicas",
                          "informeNovedades",
                          "informeAutorizacionImagen",
                          "informePlanComprasPaati",
                        ].map((parentKey) =>
                          userApplications.includes(parentKey)
                            ? menuItems
                                .filter((item) => item.parent === parentKey)
                                .map((subItem) => (
                                  <NavDropdown.Item
                                    key={subItem.path}
                                    as={Link}
                                    to={
                                      disabledItems.includes(subItem.path)
                                        ? "#"
                                        : subItem.path
                                    }
                                    onClick={(e) => {
                                      if (
                                        disabledItems.includes(subItem.path)
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                  >
                                    {subItem.icon} {subItem.label}
                                  </NavDropdown.Item>
                                ))
                            : null
                        )}
                      </NavDropdown>
                    )}

                    {/* 🔹gestor de archivos - PATTI */}
                    {userApplications.includes("gestorArchivosPAATI") && (
                      <>
                        {menuItems
                          .filter(
                            (item) => item.parent === "gestorArchivosPAATI"
                          )
                          .map((subItem) => (
                            <NavDropdown.Item
                              key={subItem.path}
                              as={Link}
                              to={
                                disabledItems.includes(subItem.path)
                                  ? "#"
                                  : subItem.path
                              }
                              onClick={(e) => {
                                if (disabledItems.includes(subItem.path)) {
                                  e.preventDefault();
                                }
                              }}
                            >
                              {subItem.icon} {subItem.label}
                            </NavDropdown.Item>
                          ))}
                      </>
                    )}
                  </NavDropdown>
                </>
              )}

              {/* Sostenibilidad Dropdown */}
              {/* Sostenibilidad Dropdown */}
              {userApplications.includes("sostenibilidad") && (
                <NavDropdown
                  title={
                    <span>
                      <FilePdfOutlined /> Sostenibilidad
                    </span>
                  }
                  id="sostenibilidad-dropdown"
                >
                  {/* Renderiza por bloques, pero SOLO si el usuario tiene el parent correspondiente */}
                  {[
                    "participantes-sostenibilidad",
                    "visitas-tecnicas-sostenibilidad",
                    "poas",
                  ].map(
                    (parentKey) =>
                      userApplications.includes(parentKey) &&
                      menuItems
                        .filter((item) => item.parent === parentKey)
                        .map((subItem) => (
                          <NavDropdown.Item
                            key={subItem.path}
                            as={Link}
                            to={
                              disabledItems.includes(subItem.path)
                                ? "#"
                                : subItem.path
                            }
                            onClick={(e) => {
                              if (disabledItems.includes(subItem.path))
                                e.preventDefault();
                            }}
                          >
                            {subItem.icon} {subItem.label}
                          </NavDropdown.Item>
                        ))
                  )}

                  {/* Compras (sub-dropdown) — solo si tiene permiso explícito */}
                  {userApplications.includes(
                    "planesdecomprasostenibilidad"
                  ) && (
                    <NavDropdown
                      title={
                        <span>
                          <ShoppingCartOutlined /> Compras
                        </span>
                      }
                      id="planes-de-compra-dropdown"
                      drop="end"
                    >
                      <NavDropdown.Item
                        as={Link}
                        to="/planesdecomprasostenibilidad"
                      >
                        <FilePdfOutlined /> Planes de Compra
                      </NavDropdown.Item>
                    </NavDropdown>
                  )}

                  {/* Dashboards Sostenibilidad — aparece si tiene permisos para alguno de los parents configurados */}
                  {[
                    "informe-visitas-tecnicas-sostenibilidad" /* , otros futuros parents */,
                  ].some((parentKey) =>
                    userApplications.includes(parentKey)
                  ) && (
                    <NavDropdown
                      title={
                        <span>
                          <FileTextOutlined /> Dashboards
                        </span>
                      }
                      id="dashboards-sostenibilidad-dropdown"
                      drop="end"
                    >
                      {menuItems
                        .filter((item) =>
                          [
                            "informe-visitas-tecnicas-sostenibilidad" /* , otros */,
                          ].includes(item.parent)
                        )
                        .filter((item) =>
                          userApplications.includes(item.parent)
                        ) // 👈 valida permiso
                        .map((subItem) => (
                          <NavDropdown.Item
                            key={subItem.path}
                            as={Link}
                            to={
                              disabledItems.includes(subItem.path)
                                ? "#"
                                : subItem.path
                            }
                            onClick={(e) => {
                              if (disabledItems.includes(subItem.path))
                                e.preventDefault();
                            }}
                          >
                            {subItem.icon} {subItem.label}
                          </NavDropdown.Item>
                        ))}
                    </NavDropdown>
                  )}
                </NavDropdown>
              )}

              {/* POA */}
              {/* Menú Desplegable "Financiero" */}
              {userApplications.includes("financiero-sostenibilidad") && (
                <NavDropdown
                  title={
                    <span>
                      <CloudSyncOutlined /> Financiero
                    </span>
                  }
                  id="financiero-dropdown"
                >
                  {/* 1. Ingreso PO */}
                  {["bodegas", "proveedores", "ordenesdeservicio"].some((key) =>
                    userApplications.includes(key)
                  ) && (
                    <NavDropdown
                      drop="end"
                      title="1. Ingreso PO"
                      id="ingreso-po-dropdown"
                    >
                      {[
                        {
                          key: "bodegas",
                          path: "/bodegas",
                          label: "Bodegas",
                        },
                        {
                          key: "proveedores",
                          path: "/proveedores",
                          label: "Proveedores",
                        },
                        {
                          key: "ordenesdeservicio",
                          path: "/ordenesdeservicio",
                          label: "Ordenes de servicio",
                        },
                      ]
                        .filter((item) => userApplications.includes(item.key))
                        .map((item) => (
                          <NavDropdown.Item
                            key={item.key}
                            as={Link}
                            to={item.path}
                          >
                            <FilePdfOutlined /> {item.label}
                          </NavDropdown.Item>
                        ))}
                    </NavDropdown>
                  )}

                  {/* 2. Asignación SOSTENIBILIDAD */}
                  {userApplications.includes("entregassostenibilidad") && (
                    <NavDropdown.Item as={Link} to="/entregassostenibilidad">
                      2. Asignación
                    </NavDropdown.Item>
                  )}

                  {/* 3. Entregas SOSTENIBILIDAD */}
                  {userApplications.includes("salidasbodega") && (
                    <NavDropdown.Item as={Link} to="/salidasbodega">
                      3. Entregas
                    </NavDropdown.Item>
                  )}

                  {/* 4. Informes */}
                  {[
                    "stock",
                    "informePlanCompras",
                    "informeOrdenesCompra",
                    "informeGeneralPorProyecto",
                    "informeEntregasByProductoPO",
                    "informeEntregas",
                    "productos",
                  ].some((key) => userApplications.includes(key)) && (
                    <NavDropdown
                      drop="end"
                      title={
                        <span>
                          <BarChartOutlined /> Informes
                        </span>
                      }
                      id="informes-dropdown"
                    >
                      {[
                        {
                          key: "stock",
                          path: "/stock",
                          label: "Stock reservas",
                        },
                        {
                          key: "informePlanCompras",
                          path: "/informePlanCompras",
                          label: "Informe plan de compras",
                        },
                        {
                          key: "informeOrdenesCompra",
                          path: "/informeOrdenesCompra",
                          label: "Informe ordenes de compra",
                        },
                        {
                          key: "informeEntregasByProductoPO",
                          path: "/informeEntregasByProductoPO",
                          label: "Informe seguimiento de PO",
                        },
                        {
                          key: "informeGeneralPorProyecto",
                          path: "/informeGeneralPorProyecto",
                          label: "Informe general por proyecto",
                        },
                        {
                          key: "informeEntregas",
                          path: "/informeEntregas",
                          label: "Informe entregas",
                        },
                        {
                          key: "productos",
                          path: "/productos",
                          label: "Productos - Plan de compras",
                        },
                      ]
                        .filter((item) => userApplications.includes(item.key))
                        .map((item) => (
                          <NavDropdown.Item
                            key={item.key}
                            as={Link}
                            to={item.path}
                          >
                            <FilePdfOutlined /> {item.label}
                          </NavDropdown.Item>
                        ))}
                    </NavDropdown>
                  )}
                </NavDropdown>
              )}

              <Nav.Link
                as="a"
                href="https://soporte.bodecom.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-link"
              >
                <CustomerServiceOutlined /> Mesa de ayuda
              </Nav.Link>
              {/* Mapa */}
              {(userApplications.includes("mapa-paati") ||
              userApplications.includes("mapa-sostenibilidad") ||
                userApplications.includes("mapa-arn")) &&
                (menuItems.some((item) => item.parent === "mapa-paati") ||
                 menuItems.some((item) => item.parent === "mapa-sostenibilidad") ||
                  menuItems.some((item) => item.parent === "mapa-arn")) && (
                  <>
                    <NavDropdown
                      title={
                        <span>
                          <CloudSyncOutlined /> Mapas
                        </span>
                      }
                      id="geovisor-paati-dropdown"
                    >
                      {userApplications.includes("mapa-paati") &&
                        menuItems
                          .filter((item) => item.parent === "mapa-paati")
                          .map((subItem) => (
                            <NavDropdown.Item
                              key={subItem.path}
                              as={Link}
                              to={
                                disabledItems.includes(subItem.path)
                                  ? "#"
                                  : subItem.path
                              }
                              onClick={(e) => {
                                if (disabledItems.includes(subItem.path)) {
                                  e.preventDefault();
                                }
                              }}
                            >
                              {subItem.icon} {subItem.label}
                            </NavDropdown.Item>
                          ))}

                      {userApplications.includes("mapa-sostenibilidad") &&
                        menuItems
                          .filter((item) => item.parent === "mapa-sostenibilidad")
                          .map((subItem) => (
                            <NavDropdown.Item
                              key={subItem.path}
                              as={Link}
                              to={
                                disabledItems.includes(subItem.path)
                                  ? "#"
                                  : subItem.path
                              }
                              onClick={(e) => {
                                if (disabledItems.includes(subItem.path)) {
                                  e.preventDefault();
                                }
                              }}
                            >
                              {subItem.icon} {subItem.label}
                            </NavDropdown.Item>
                          ))}

                      {userApplications.includes("mapa-arn") &&
                        menuItems
                          .filter((item) => item.parent === "mapa-arn")
                          .map((subItem) => (
                            <NavDropdown.Item
                              key={subItem.path}
                              as={Link}
                              to={
                                disabledItems.includes(subItem.path)
                                  ? "#"
                                  : subItem.path
                              }
                              onClick={(e) => {
                                if (disabledItems.includes(subItem.path)) {
                                  e.preventDefault();
                                }
                              }}
                            >
                              {subItem.icon} {subItem.label}
                            </NavDropdown.Item>
                          ))}


                    
                    </NavDropdown>
                  </>
                )}

              {/* Monitoreo Dropdown */}
              {/* Monitoreo Dropdown */}
              {(userApplications.includes("historial-visitas-paati") ||
                userApplications.includes("informe-espiga") ||
                userApplications.includes("informe-ingreso-po")) && (
                <NavDropdown
                  title={
                    <span>
                      <CloudSyncOutlined /> Monitoreo
                    </span>
                  }
                  id="monitoreo-dropdown"
                >
                  {userApplications.includes("historial-visitas-paati") &&
                    menuItems
                      .filter(
                        (item) => item.parent === "historial-visitas-paati"
                      )
                      .map((subItem) => (
                        <NavDropdown.Item
                          key={subItem.path}
                          as={Link}
                          to={
                            disabledItems.includes(subItem.path)
                              ? "#"
                              : subItem.path
                          }
                          onClick={(e) => {
                            if (disabledItems.includes(subItem.path)) {
                              e.preventDefault();
                            }
                          }}
                        >
                          {subItem.icon} {subItem.label}
                        </NavDropdown.Item>
                      ))}

                  {userApplications.includes("informe-espiga") &&
                    menuItems
                      .filter((item) => item.parent === "informe-espiga")
                      .map((subItem) => (
                        <NavDropdown.Item
                          key={subItem.path}
                          as={Link}
                          to={
                            disabledItems.includes(subItem.path)
                              ? "#"
                              : subItem.path
                          }
                          onClick={(e) => {
                            if (disabledItems.includes(subItem.path)) {
                              e.preventDefault();
                            }
                          }}
                        >
                          {subItem.icon} {subItem.label}
                        </NavDropdown.Item>
                      ))}

                  {userApplications.includes("informe-ingreso-po") &&
                    menuItems
                      .filter((item) => item.parent === "informe-ingreso-po")
                      .map((subItem) => (
                        <NavDropdown.Item
                          key={subItem.path}
                          as={Link}
                          to={
                            disabledItems.includes(subItem.path)
                              ? "#"
                              : subItem.path
                          }
                          onClick={(e) => {
                            if (disabledItems.includes(subItem.path)) {
                              e.preventDefault();
                            }
                          }}
                        >
                          {subItem.icon} {subItem.label}
                        </NavDropdown.Item>
                      ))}
                </NavDropdown>
              )}

              {/* Salir */}
              <Nav.Link onClick={handleLogout} className="nav-link">
                <LogoutOutlined /> Salir
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </div>
      </div>
    </Navbar>
  );
};

export default NavBodecom;
